module.exports = __webpack_public_path__ + "img/join-us-header-bg-img2.dfb14368.png";